const DevicesData = [
    {
        type: 'Antlia ',
        ID: '1DS18ANT',
        name: 'Jayadeva Hospital',
        date: '16/05/2022',
        doctor: 'Dr.Koushik'
       
    },
    {
        type: 'Antlia Mini app',
        ID: '189718A7',
        name: 'Manipal Hospitals',
        date: '01/03/2020',
        doctor: 'Dr.Hemanth'
       
    },
    {
        type: 'Antlia Pro',
        ID: '87TS626',
        name: 'Apollo Hospital',
        date: '17/11/2022',
        doctor: 'Dr.Suma Herimath'
       
    },
    {
        type: 'Antlia Mini app',
        ID: '1DS18ANT',
        name: 'Kasturba Hospital',
        date: '24/09/2022',
        doctor: 'Dr.Samarth Mukherji'
       
    },
    
]

export default DevicesData;